import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { callGPTAPI } from '../utils/api';
export function GptApiTest() {
  const [instructions, setInstructions] = useState('');
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const handleRun = async () => {
    if (!instructions.trim() || !prompt.trim()) {
      setError('Both Instructions and Prompt are required');
      return;
    }
    setLoading(true);
    setError(null);
    setResponse(null);
    try {
      const result = await callGPTAPI(instructions, prompt);
      setResponse(result);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return <div className="space-y-6" data-id="element-4623" data-mp="1jd9h50kdeppg">
      {/* Header */}
      <div className="flex items-center gap-4" data-id="element-4624" data-mp="1jbzjgchfjjjc">
        <Link to="/api-test" className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors" data-id="element-4625" data-mp="1fbo0r58mntai">
          <ArrowLeft className="h-5 w-5" data-id="element-4626" data-mp="1ajecrur2p3av" />
        </Link>
        <div data-id="element-4627" data-mp="15me73ky4y2ka">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-4628" data-mp="15ktalps9g9js">GPT API Test</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4629" data-mp="10nayjqiy5e7k">
            Test GPT API integration with custom instructions and prompts.
          </p>
        </div>
      </div>

      {/* Info Banner */}
      <div className="bg-gradient-to-br from-purple-50 to-blue-50 border border-purple-200 rounded-lg p-4" data-id="element-4630" data-mp="rltkset0hom1">
        <p className="text-sm text-purple-800" data-id="element-4631" data-mp="mnjou1zgqjzd">
          <strong data-id="element-4632" data-mp="mourfyh69low">GPT API Test</strong> — Provide system instructions and a
          prompt to test the GPT API integration. The response will be displayed
          below.
        </p>
      </div>

      {/* Form */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-6" data-id="element-4633" data-mp="2gz6u6ifze2u0">
        <div data-id="element-4634" data-mp="304d3i8v90y8d">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4635" data-mp="303tiuke7rvqn">
            Instructions
          </label>
          <textarea value={instructions} onChange={e => setInstructions(e.target.value)} rows={6} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-sm font-mono" placeholder="Enter system instructions for the GPT model..." data-id="element-4636" data-mp="2r4y9x0jsc7jn" />
          <p className="mt-1 text-xs text-gray-500" data-id="element-4637" data-mp="3nup93d30uivs">
            System-level instructions that guide the model's behavior
          </p>
        </div>

        <div data-id="element-4638" data-mp="3eu13n6rp1qui">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4639" data-mp="3etrc3er03bmp">
            Prompt
          </label>
          <textarea value={prompt} onChange={e => setPrompt(e.target.value)} rows={8} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-sm font-mono" placeholder="Enter your prompt..." data-id="element-4640" data-mp="1yfj1miji8srf" />
          <p className="mt-1 text-xs text-gray-500" data-id="element-4641" data-mp="1qwi6akiuy5f5">
            The user message or query to send to the model
          </p>
        </div>

        <div data-id="element-4642" data-mp="1zxprc0wd59ra">
          <button onClick={handleRun} disabled={loading || !instructions.trim() || !prompt.trim()} className="inline-flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white text-sm font-medium rounded-md hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-4643" data-mp="1zwy3xdcx6ic3">
            {loading ? <>
                <Loader2 className="h-4 w-4 animate-spin" data-id="element-4644" data-mp="1h6gh1perqgyn" />
                Running...
              </> : 'Run'}
          </button>
        </div>
      </div>

      {/* Error Display */}
      {error && <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-4645" data-mp="ohrmk987x9vv">
          <p className="text-sm font-medium text-red-800" data-id="element-4646" data-mp="1262vosoa2u36">Error</p>
          <p className="text-sm text-red-700 mt-1 font-mono whitespace-pre-wrap" data-id="element-4647" data-mp="173uy4gmjtylm">
            {error}
          </p>
        </div>}

      {/* Response Display */}
      {response && <div data-id="element-4648" data-mp="1gtxnm6ugouf7">
          <div className="flex items-center justify-between mb-2" data-id="element-4649" data-mp="1gtnzypww2zco">
            <p className="text-sm font-medium text-gray-700" data-id="element-4650" data-mp="1gw0oxn12e9z8">Response</p>
            <button onClick={() => {
          setResponse(null);
          setError(null);
        }} className="px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4651" data-mp="1kuzqcxnl7olx">
              Clear
            </button>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-5 max-h-[60vh] overflow-auto" data-id="element-4652" data-mp="1zqfobdrag4nl">
            <pre className="text-sm text-gray-900 whitespace-pre-wrap break-words" data-id="element-4653" data-mp="5er5v1luljyg">
              {response}
            </pre>
          </div>
        </div>}
    </div>;
}